import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const TriBetLink = () => {
  const [ok, setOk] = useState(false);
  useEffect(() => {
    fetch(`${API_URL}/api/feed/tribet-access`, { credentials: 'include' })
      .then((r) => (r.ok ? r.json() : {})).then((d) => setOk(!!d.allowed && !d.admin)).catch(() => {});
  }, []);
  if (!ok) return null;
  return (
    <Link to="/tribet" className="text-sm text-sky-400 hover:text-sky-300 transition" data-testid="tribet-dashboard-link">
      TriBet Dashboard
    </Link>
  );
};
